export default __webpack_public_path__ + "static/media/020-ice cream sandwich.5180294c.svg";